import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CreditCard, MoreVertical } from 'lucide-react';
import { Button } from '@vaiu/ui/button';
import { cn } from '@vaiu/utils';

interface BottomNavBarProps {
  onMenuClick: () => void;
  className?: string;
}

/** Mobile bottom bar — Pay plus Menu; all other links live in the Menu drawer. */
const BottomNavBar: React.FC<BottomNavBarProps> = ({
  onMenuClick,
  className,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  const navItems = [
    {
      icon: CreditCard,
      label: 'Pay',
      onClick: () => navigate('/pay'),
      active: location.pathname === '/pay',
    },
    {
      icon: MoreVertical,
      label: 'Menu',
      onClick: onMenuClick,
      active: false,
    },
  ];

  return (
    <div
      className={cn(
        'fixed bottom-0 left-0 right-0 bg-white border-t shadow-lg z-50 md:hidden w-full',
        className
      )}
    >
      <div className="flex items-center justify-center h-16 px-4 max-w-full gap-2">
        {navItems.map((item) => (
          <Button
            key={item.label}
            variant="ghost"
            size="sm"
            onClick={item.onClick}
            className={cn(
              'flex flex-col items-center justify-center h-full flex-1 rounded-md min-w-0 px-2 max-w-[8rem]',
              'hover:bg-gray-50 active:bg-gray-100',
              item.active && 'bg-gray-50 text-primary'
            )}
          >
            <item.icon className="w-5 h-5 mb-1 flex-shrink-0" />
            <span className="text-xs truncate">{item.label}</span>
          </Button>
        ))}
      </div>
    </div>
  );
};

export default BottomNavBar;
